import {
  InputField,
  EfsMelcoEfsModelsSchemaListItem,
} from "melco-shared-logic";
import { useTranslation } from "react-i18next";
import { useCustomTokenField } from "../../hooks/inputFormats/useCustomTokenField";

type CustomTokenFieldProps = {
  dataAssignments: EfsMelcoEfsModelsSchemaListItem[];
  attribute?: string;
};

export const CustomTokenField: React.FC<CustomTokenFieldProps> = ({
  dataAssignments,
  attribute,
}) => {
  const { t } = useTranslation();

  const name = "value";
  const fieldName = attribute ? [attribute, name].join(".") : name;

  const isCustomTokenFieldEnabled = useCustomTokenField(
    dataAssignments,
    `${attribute}.dataSource`
  );

  if (!isCustomTokenFieldEnabled) {
    return null;
  }

  return (
    <InputField
      name={fieldName}
      label={t("dataMappings.form.label.customToken")}
      info={t("dataMappings.form.info.customToken")}
    />
  );
};
